import React from 'react';
import { Alert, Box, Dialog, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { Close, ContentCopy } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';

const NewSecretModal = ({ open, onClose, secret }) => {
  const dispatch = useDispatch();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      dispatch(
        showSnackbar({
          message: 'Client Secret copied to clipboard',
          severity: 'success',
        }),
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: 'Failed to copy to clipboard',
          severity: 'error',
        }),
      );
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth={false}
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: '435px',
          maxWidth: '90vw',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        New Client Secret Generated
        <IconButton onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 2 }}>
        <Alert
          severity="info"
          sx={{
            mb: 3,
            backgroundColor: '#E6F4FF',
            color: 'text.primary',
            borderColor: 'primary.main',
            '& .MuiAlert-icon': {
              alignItems: 'flex-start',
              mt: 0.5,
              color: 'primary.main',
            },
          }}
          icon={
            <Typography variant="h6" sx={{ fontSize: '1.2rem' }}>
              ℹ️
            </Typography>
          }
        >
          Please copy your new secret and store it in a safe place.
        </Alert>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              fullWidth
              value={secret}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'grey.50',
                  '& fieldset': {
                    borderColor: 'grey.300',
                  },
                  '&:hover fieldset': {
                    borderColor: 'grey.400',
                  },
                },
              }}
            />
            <IconButton
              onClick={handleCopy}
              size="small"
              sx={{
                border: '1px solid',
                borderColor: 'grey.300',
                backgroundColor: 'grey.100',
                borderRadius: 1,
                minWidth: 40,
                height: 40,
                '&:hover': {
                  backgroundColor: 'grey.200',
                },
              }}
            >
              <ContentCopy fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NewSecretModal;
